import React, { ChangeEvent } from 'react';
import { LoadingButton } from 'components/loadingbutton/LoadingButton';
import Disclaimer from 'components/disclaimer/Disclaimer';
import ClockIcon from 'assets/livenicons/ic_clock.svg';
import styles from './styles.module.scss';
import BottomInputContainer from '../bottominputcontainer/BottomInputContainer';
import { PasswordInput } from '../passwordinput/PasswordInput';

type Props = {
  countryCode?: string;
  emailError: string;
  email: string;
  emailFocused: boolean;
  passwordError: string;
  password: string;
  isLoading: boolean;
  isPasswordVisible: boolean;
  isRestrictMailing?: boolean;
  handleSubmit: () => void;
  onEmailFocusHandler: () => void;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onEmailChange: (email: string) => void;
  onEmailBlurHandler: () => void;
  onHandleCheckboxClick: () => void;
};

const SignInForm = ({
  emailError,
  email,
  isLoading,
  countryCode,
  password,
  passwordError,
  isPasswordVisible,
  isRestrictMailing,
  onPasswordChange,
  onHandleCheckboxClick,
  handleSubmit,
  onEmailFocusHandler,
  onEmailChange,
  onEmailBlurHandler,
}: Props) => {
  return (
    <form className={styles.signInForm} onSubmit={handleSubmit} noValidate>
      <div className={styles.inputContainer}>
        <input
          type="email"
          className={emailError ? styles.invalid : ''}
          value={email}
          placeholder="Enter your email to get your plan"
          onFocus={onEmailFocusHandler}
          onBlur={onEmailBlurHandler}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onEmailChange(e.target.value);
          }}
        />
      </div>

      <div className={styles.signInError}>{emailError}</div>

      <BottomInputContainer
        countryCode={countryCode}
        isRestrictMailing={isRestrictMailing}
        className={styles.bottomInputContainer}
        onHandleCheckboxClick={onHandleCheckboxClick}
      />

      {isPasswordVisible && (
        <>
          <PasswordInput
            value={password}
            isValid={!passwordError}
            onChange={onPasswordChange}
          />
          <div className={styles.signInError}>{passwordError}</div>
        </>
      )}

      <LoadingButton
        disabled={false}
        className={styles.button}
        isLoading={isLoading}
        label="Continue"
        onClick={handleSubmit}
      />

      <div className={styles.disclaimer}>
        <img src={ClockIcon} alt="" />
        We respect your privacy and are committed to protecting your personal
        data. Your data will be processed according to our Privacy policy.
      </div>

      <Disclaimer />
    </form>
  );
};

export default SignInForm;
